import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/static/img/simnach_logo.png",
    height: "300",
    width: "700",
    class: "rounded",
    alt: "..."
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}